import React, { useEffect } from 'react';
import UnifiedNavigation from '../../components/Navigation/UnifiedNavigation';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import Footer from '../../components/Footer/Footer';
import { images } from '../../components/shared/assets';
import { initializeDragScroll } from '../../utils/interactiveFeatures';
import './DiningAtacama.css';

const DiningAtacama: React.FC = () => {
  useEffect(() => {
    // Initialize horizontal scroll for the carousel
    const cleanup = initializeDragScroll('dining-carousel');
    return cleanup;
  }, []);

  const diningPanels = [
    {
      id: 'native-corn-section',
      type: 'split-content',
      textSide: 'left',
      imageSide: 'right',
      image: '/assets/figma/0ab6a73916c755c399fa1f8e74a1d00a3c98d08c.png',
      title: 'Native corn and potatoes, fresh seafood from the Pacific Ocean.',
      content: 'Et quam donec a commodo. Ut dictum ut proin urna nunc. Ut diam tortor aliquet enim iaculis donec feugiat quis non. Sapien posuere et tortor gravida odio lobortis proin placerat. Curabitur dignissim hendrerit orci vestibulum a faucibus. Eu eget tincidunt fusce dui fames id in mauris. Venenatis accumsan non vestibulum eget.',
      buttons: [
        { text: 'reserve a table', type: 'primary' },
        { text: 'see the menu', type: 'secondary' }
      ]
    },
    {
      id: 'three-images-gallery',
      type: 'image-gallery',
      images: [
        '/assets/figma/f75342c4b2ab0fc6ca2aa5d5f9bcae3bd1f4ce00.png',
        '/assets/figma/4a1145649b8aefa4a04946dd103d1ec48dec7f70.png',
        '/assets/figma/a8fd8b9d64ed28dbea678232ef8d15d9e99991f4.png'
      ]
    },
    {
      id: 'landscape-dining',
      type: 'full-landscape',
      image: '/assets/figma/7ff1e3170c7790b6bdce0d38acd43a1cb72f5b12.png'
    },
    {
      id: 'chef-showcase',
      type: 'chef-feature',
      image: '/assets/figma/19a61c78a622e78514f1d4a1744890e613619ecc.png',
      title: "Awasi's Chefs Showcase the Best Local Flavors and Ingredients",
      content: 'Facilisis vitae interdum urna dictum ac. Est sapien est lectus in duis lacus arcu diam. Sapien platea lorem nec aliquam nisl sagittis. In duis tellus eu malesuada feugiat cursus felis. Amet scelerisque nisl euismod sapien aliquet dui aenean tincidunt donec. Nisl nunc orci nec nec cras maecenas nisl at. Molestie bibendum urna eleifend ultrices erat senectus tempor sapien. Nisl lectus amet mi.',
      button: { text: 'read more', type: 'tertiary' }
    },
    {
      id: 'chef-profile',
      type: 'chef-profile',
      textSide: 'left',
      imageSide: 'center',
      gallerySide: 'right',
      chefImage: '/assets/figma/eb4cd6324bc3acb7f1d57af01d07ea063da795be.png',
      name: 'Sebastian Prieto',
      role: 'Head chef',
      property: 'awasi atacama',
      content: 'Et quam donec a commodo. Ut dictum ut proin urna nunc. Ut diam tortor aliquet enim iaculis donec feugiat quis non. Sapien posuere et tortor gravida odio lobortis proin placerat. Curabitur dignissim hendrerit orci vestibulum a faucibus. Eu eget tincidunt fusce dui fames id in mauris. Venenatis accumsan non vestibulum eget.',
      galleryImages: [
        '/assets/figma/1ef95176f2b30cea6c026a2313b7a8c76ff9b546.png',
        '/assets/figma/032bfce9c5dc96f8ccad74cc1748651d986dd7f4.png',
        '/assets/figma/ebde2af7a1831bcf09cd4ea0b0701de10247e40c.png',
        '/assets/figma/4d4e790dd105e45b604aa440eb2541894dd317b3.png',
        '/assets/figma/e4b1294f7fdb8bb50ef6b56bc1b1317911f04905.png'
      ],
      button: { text: 'read more', type: 'tertiary' }
    },
    {
      id: 'gastronomic-journey',
      type: 'split-content-final',
      textSide: 'left',
      imageSide: 'right',
      backgroundColor: 'var(--color-atacama)',
      image: '/assets/figma/ad27e2e8a93f4acc6b0535be4d8e78ff3e439d7c.png',
      title: 'Making an unforgettable gastronomic journey',
      content: 'At nibh suspendisse id sed leo nisi. In consectetur nulla iaculis massa mi turpis in feugiat pulvinar. Tortor hendrerit tortor pulvinar ornare. Nulla tortor sed sem a ipsum. Tellus eget adipiscing felis fringilla in semper dignissim donec. Lacus lectus in velit in enim et id.',
      button: { text: 'see experiences', type: 'tertiary' },
      logoOverlay: '/assets/figma/f78d9ea45f8dc3a1b73ef28f0830d6c98fc6c32d.png'
    }
  ];

  return (
    <div className="dining-page">
      <UnifiedNavigation variant="light" destination="atacama" />
      
      {/* Horizontal Carousel Section */}
      <section className="dining-carousel-section horizontal-carousel-section" data-scroll-section="dining">
        <div 
          id="dining-carousel"
          className="dining-carousel"
        >
          {diningPanels.map((panel, index) => {
            // Full Landscape Panel
            if (panel.type === 'full-landscape') {
              return (
                <div key={panel.id} className="dining-panel dining-panel--full-landscape">
                  <div 
                    className="dining-panel__landscape-bg"
                    style={{ backgroundImage: `url('${panel.image}')` }}
                  />
                </div>
              );
            }

            // Split Content Panel (Text + Image)
            if (panel.type === 'split-content') {
              return (
                <div key={panel.id} className="dining-panel dining-panel--split-content">
                  <div className="dining-panel__text-section">
                    <div className="dining-panel__text-container">
                      <h2 className="dining-panel__title">{panel.title}</h2>
                      <p className="dining-panel__text">{panel.content}</p>
                      <div className="dining-panel__buttons">
                        {panel.buttons?.map((btn, btnIndex) => (
                          <button key={btnIndex} className={`dining-panel__button dining-panel__button--${btn.type}`}>
                            {btn.text}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="dining-panel__image-section">
                    <div 
                      className="dining-panel__image-bg"
                      style={{ backgroundImage: `url('${panel.image}')` }}
                    />
                  </div>
                </div>
              );
            }

            // Image Gallery Panel
            if (panel.type === 'image-gallery' && panel.images) {
              return (
                <div key={panel.id} className="dining-panel dining-panel--image-gallery">
                  <div className="dining-panel__gallery-container">
                    <div 
                      className="dining-panel__gallery-image dining-panel__gallery-image--1"
                      style={{ backgroundImage: `url('${panel.images[0]}')` }}
                    />
                    <div 
                      className="dining-panel__gallery-image dining-panel__gallery-image--2"
                      style={{ backgroundImage: `url('${panel.images[1]}')` }}
                    />
                    <div 
                      className="dining-panel__gallery-image dining-panel__gallery-image--3"
                      style={{ backgroundImage: `url('${panel.images[2]}')` }}
                    />
                  </div>
                </div>
              );
            }

            // Chef Feature Panel
            if (panel.type === 'chef-feature') {
              return (
                <div key={panel.id} className="dining-panel dining-panel--chef-feature">
                  <div className="dining-panel__chef-content">
                    <div 
                      className="dining-panel__chef-image"
                      style={{ backgroundImage: `url('${panel.image}')` }}
                    />
                    <div className="dining-panel__chef-text">
                      <h2 className="dining-panel__chef-title">{panel.title}</h2>
                      <p className="dining-panel__chef-description">{panel.content}</p>
                      {panel.button && (
                        <button className="dining-panel__button dining-panel__button--tertiary">
                          {panel.button.text}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            }

            // Chef Profile Panel
            if (panel.type === 'chef-profile') {
              return (
                <div key={panel.id} className="dining-panel dining-panel--chef-profile">
                  <div className="dining-panel__profile-text">
                    <div className="dining-panel__profile-content">
                      <h2 className="dining-panel__profile-name">{panel.name}</h2>
                      <div className="dining-panel__profile-role">
                        <span className="dining-panel__profile-property">{panel.property}</span>
                        <span className="dining-panel__profile-separator">-</span>
                        <span className="dining-panel__profile-title">{panel.role}</span>
                      </div>
                      <p className="dining-panel__profile-description">{panel.content}</p>
                      {panel.button && (
                        <button className="dining-panel__button dining-panel__button--tertiary">
                          {panel.button.text}
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="dining-panel__profile-image">
                    <div 
                      className="dining-panel__profile-photo"
                      style={{ backgroundImage: `url('${panel.chefImage}')` }}
                    />
                  </div>
                  <div className="dining-panel__profile-gallery">
                    <div className="dining-panel__profile-gallery-container">
                      {panel.galleryImages && panel.galleryImages.slice(0, 3).map((img, imgIndex) => (
                        <div 
                          key={imgIndex}
                          className={`dining-panel__profile-gallery-image dining-panel__profile-gallery-image--${imgIndex + 1}`}
                          style={{ backgroundImage: `url('${img}')` }}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              );
            }

            // Split Content Final Panel (Gastronomic Journey)
            if (panel.type === 'split-content-final') {
              return (
                <div key={panel.id} className="dining-panel dining-panel--split-content-final">
                  <div 
                    className="dining-panel__final-text-section"
                    style={{ backgroundColor: panel.backgroundColor }}
                  >
                    <div className="dining-panel__final-text-container">
                      <h2 className="dining-panel__final-title">{panel.title}</h2>
                      <p className="dining-panel__final-text">{panel.content}</p>
                      {panel.button && (
                        <button className="dining-panel__button dining-panel__button--final">
                          {panel.button.text}
                        </button>
                      )}
                    </div>
                    {panel.logoOverlay && (
                      <div 
                        className="dining-panel__final-logo-overlay"
                        style={{ backgroundImage: `url('${panel.logoOverlay}')` }}
                      />
                    )}
                  </div>
                  <div className="dining-panel__final-image-section">
                    <div 
                      className="dining-panel__final-image-bg"
                      style={{ backgroundImage: `url('${panel.image}')` }}
                    />
                  </div>
                </div>
              );
            }

            return null;
          })}
        </div>
      </section>

      <InstagramSection />
      <Footer variant="atacama" />
    </div>
  );
};

export default DiningAtacama;